<template>
  <div class="matchDetail">
    <page-header :noBack="true">
      赛事详情
    </page-header>
    <div class="infor_wrap">
      <div class="banners">
        <img class="banner" :src="infor.cover" alt="">
      </div>
      <div class="infor">
        <div class="title">{{infor.name}}</div>
        <div class="time">{{infor.matchStartTime}}-{{infor.matchEndTime}}</div>
      </div>
    </div>
    <div class="details" v-html="infor.details"></div>
    <div class="btns">
      <router-link to="/download" tag="div" class="btn btn_1">题目练习</router-link>
      <router-link to="/download" tag="div" class="btn btn_2">投票</router-link>
    </div>
    <div class="download_wrap">
      <div class="left_wrap">
        <img class="logo" src="../assets/img/logo_1.png" alt="">
        <div class="name">学习国防</div>
      </div>
      <router-link to="/download" tag="div" class="btn">下载App</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: "matchDetail",
  data() {
    return {
      id: this.$route.query.id,
      infor: {}
    };
  },
  mounted () {
    this.getInfo();
  },
  methods: {
    getInfo () {
      this.axios.get('/xxgf-api/activity/match?id=' + this.id)
        .then(({data}) => {
          if (data.code === 200) {
            this.infor = data.data;
          }
        })
    },
  }
};
</script>

<style lang="scss">
.matchDetail {
  padding-top:94px;
  padding-bottom:210px;
  .infor_wrap{
    margin-bottom:20px;
    .banners{
      width:100%;
      height:420px;
      .banner{
        width:100%;
        height:100%;
        object-fit: cover;
      }
    }
    .infor{
      width:100%;
      min-height:144px;
      padding:30px;
      background:#fff;
      .title{
        font-size:36px;
      }
      .time{
        font-size:24px;
        color:#777;
      }
    }
  }
  .details{
    padding: 30px;
    background:#fff;
    img{
      max-width:100%;
    }
  }
  .btns{
    position:fixed;
    left:0;
    bottom:120px;
    z-index:10;
    width:100%;
    height:90px;
    display:flex;
    .btn{
      flex:1;
      height:90px;
      line-height:90px;
      text-align:center;
      font-size:32px;
      color:#fff;
      &.btn_1{
        background:linear-gradient(90deg, #FFCA00, #FF9503);
      }
      &.btn_2{
        background:linear-gradient(90deg, #FE7702, #FF4A01);
      }
    }
  }
}
</style>
